<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="shippingMethod.Name" label="Phương thức" class="input-group--focused"></v-text-field>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
export default {
    computed: {
        ...mapState({
            loading: state => state.shippingMethod.loading,
            shippingMethod: state => state.shippingMethod.selected
        }),
        modifyId() {
            return this.$route.params.Pid;
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("shippingMethod/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("shippingMethod/setDetail", { data: {
                        ID: 0,
                        Name: ''
                    }
                })
            }
        },
        saveData() {
            this.$store.dispatch("shippingMethod/setDetail", {
                data: this.shippingMethod,
                id: this.shippingMethod.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "ShippingMethodList");
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.shippingMethod.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>